(function () {
  'use strict';

  angular.module('app').component('teamMemberContactList', teamMemberContactList());

  function teamMemberContactList() {
    return {
      bindings: {
        teamMember: '<',
        teamMemberContacts: '=',
      },
      controller: TeamMemberContactListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/team-members/team-member-contacts/team-member-contact-list/team-member-contact-list.component.html',
    };
  }

  TeamMemberContactListComponent.$inject = [
    'UtilService',
    'AbilityService',
    'TeamMemberContactService',
  ];

  function TeamMemberContactListComponent(UtilService, AbilityService, TeamMemberContactService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_teammember_accountadmin'),
      canShow: AbilityService.can('show_teammember_accountadmin'),
      canUpdate: AbilityService.can('update_teammember_accountadmin'),
      canDestroy: AbilityService.can('destroy_teammember_accountadmin'),
    };

    // Methods
    vm.addTeamMemberContact = addTeamMemberContact;
    vm.showTeamMemberContact = showTeamMemberContact;
    vm.changeTeamMemberContactStatus = changeTeamMemberContactStatus;
    vm.changeTeamMemberContactDefault = changeTeamMemberContactDefault;
    vm.deleteTeamMemberContact = deleteTeamMemberContact;

    vm.$onInit = function () {
      checkDefaultTeamMemberContact();
    };

    function addTeamMemberContact() {
      if (!vm.permissions.canCreate) return;

      const successCallback = function (selectedItem) {
        vm.teamMemberContacts.push(selectedItem);
        vm.UtilService.itemListChanged(selectedItem.id);

        checkDefaultTeamMemberContact();
      };

      TeamMemberContactService.openTeamMemberContactModal(
        {},
        vm.teamMember,
        'create',
        successCallback
      );
    }

    function showTeamMemberContact(teamMemberContact, mode) {
      if (!vm.permissions.canShow) return;

      const successCallback = function () {};

      TeamMemberContactService.openTeamMemberContactModal(
        teamMemberContact,
        vm.teamMember,
        mode,
        successCallback
      );
    }

    function changeTeamMemberContactStatus(teamMemberContact) {
      if (!vm.permissions.canUpdate || teamMemberContact.is_default) return;

      TeamMemberContactService.changeTeamMemberContactStatus(teamMemberContact, vm.teamMember.id);
    }

    function changeTeamMemberContactDefault(teamMemberContact) {
      if (!vm.permissions.canUpdate || teamMemberContact.is_default) return;

      const successCallback = function () {
        vm.teamMemberContacts.forEach(function (contact) {
          contact.is_default = contact.id === teamMemberContact.id;
        });

        checkDefaultTeamMemberContact();
      };

      TeamMemberContactService.changeTeamMemberContactDefault(teamMemberContact, successCallback);
    }

    function deleteTeamMemberContact(teamMemberContact, index) {
      if (!vm.permissions.canDestroy || teamMemberContact.is_default) return;

      const successCallback = function (index) {
        vm.teamMemberContacts.splice(index, 1);
      };

      TeamMemberContactService.deleteTeamMemberContact(
        teamMemberContact,
        vm.teamMember.id,
        successCallback,
        index
      );
    }

    function checkDefaultTeamMemberContact() {
      vm.errorDefaultTeamMemberContact = !vm.teamMemberContacts.find((item) => item.is_default);
    }
  }
})();
